import client from './api-client';

export const serviceGetCfgForm = async (query) => {
    try {
        const response = await client.get(`cfg-forms?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetSolicitudGestion = async (query) => {
    try {
        const response = await client.get(`gestion-implicado/cierre-defensa/solicitud-cierre?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetConfirmaCierreRechazo = async (query) => {
    try {
        const response = await client.get(`grupo-estado?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetDetalles = async (query) => {
    try {
        const response = await client.get(`detalles?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetDestinatarios = async (query) => {
    try {
        const response = await client.get(`gestion-implicado/cierre-defensa/destinatarios-carta?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceActualizarDestinatario = async(body) => {
    try {
        const response = await client.post('gestion-implicado/cierre-defensa/destinatarios-carta', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}

export const serviceGetProcesosJudiciales = async (query) => {
    try {
        const response = await client.get(`gestion-implicado/cierre-defensa/proceso-judicial?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetInforme = async(query) => {
    try {
        const response = await client.getDocumento(`get-file?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return response.data
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}

// Detalle Cierre
export const serviceGetCoberturaProvisiones = async(query) => {
    try {
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } 
    catch(error){
        throw error;
    }
}

export const serviceGetGestionImplicado = async (query) => {
    try {
        const response = await client.getImplicado(`getion-implicado?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetPretensionesVigentes = async (query) => {
    try {
        const response = await client.getImplicado(`pretensiones/coberturas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetComboMonedas = async (query) => {
    try {
        const response = await client.getImplicado(`monedas?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch (error) {
        throw error;
    }
}

export const serviceGetBancos = async (query) => {
    try {
        const response = await client.getImplicado(`bancos?q=${query}`);

        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    }
    catch (error) {
        throw error;
    }
}

export const serviceGetDetalle = async (query) => {
    try {
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) return response.data.object;
        else throw new Error(response.data.message);
    } 
    catch (error) {
        throw error;
    }
}

export const serviceGetCasoImplicado = async(query) => {
    try {
        const response = await client.getImplicado(`caso/implicado?q=${query}`);
      
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);
    } 
    catch(error) {
        throw error;
    }
}

export const serviceVisarRechazarCierre = async(body) => {
    try {
        const response = await client.post('gestion-implicado/cierre-defensa/confirmar', body);
        return response.data;
    } catch(error) {
        throw error;
    }
}

export const serviceGetSolicitudes = async(query) => {
    try {
        
        const response = await client.get(`informe-profesional/solicitudes?q=${query}`);      
        
        if (response.status === 200 && response.data.code === 1) return response.data.object
        else throw new Error(response.data.message);

    } catch(error){
        throw error;
    }
}